import Vue from 'vue';

export default {
  reset({ commit }) {
    Vue.$log.info('store.zip.actions.reset.started');
    commit('reset');
  },
};
